import React from "react";
import { TIERS_PATH } from "utils/constants/paths";
import { IRouteItem, Loadable } from "@techzyapp/ui-lib";

const Tiers = Loadable(React.lazy(() => import("./View")));

export const TiersRoute: IRouteItem = {
  path: TIERS_PATH,
  iconName: "Rank",
  element: React.createElement(Tiers),
  name: "Tiers",
  accessKeys: ["SuperAdmin", "Admin"],
};
